import { reconstructMessage } from './reconstruct-batched-message';
export const processChunkMessage = (msgEvent, chunkedMeesageQueue) => {
    const { uuid, message: { sequence, sequenceStartTime }, } = msgEvent;
    const sequenceNo = (sequenceStartTime ?? 0) + sequence;
    if (uuid) {
        const previousChunkedMessagesMap = chunkedMeesageQueue[uuid];
        if (previousChunkedMessagesMap) {
            const previousChunkedMsgEvents = previousChunkedMessagesMap[sequenceNo];
            if (previousChunkedMsgEvents) {
                if (msgEvent.message.batchSize - previousChunkedMsgEvents.length === 1) {
                    const previouseChunkedMessages = previousChunkedMsgEvents.map(m => m.message);
                    const finalMessage = reconstructMessage([
                        ...previouseChunkedMessages,
                        msgEvent.message,
                    ]);
                    if (finalMessage) {
                        delete chunkedMeesageQueue[uuid];
                        return { ...msgEvent, message: finalMessage };
                    }
                    return undefined;
                }
                previousChunkedMsgEvents.push(msgEvent);
            }
            else {
                chunkedMeesageQueue[uuid] = {
                    [sequenceNo]: [msgEvent],
                };
            }
        }
        else {
            chunkedMeesageQueue[uuid] = {
                [sequenceNo]: [msgEvent],
            };
        }
    }
    return undefined;
};
// TODO: What about remaining chunked messages in the queue?
export function processChannelMessages(messages) {
    const chunkedMeesageQueue = {};
    const processedMessages = [];
    messages.forEach(msgEvent => {
        if ('batchSize' in msgEvent.message) {
            const message = processChunkMessage(msgEvent, chunkedMeesageQueue);
            if (message) {
                processedMessages.push(message);
            }
        }
        else {
            processedMessages.push(msgEvent);
        }
    });
    return processedMessages;
}
//# sourceMappingURL=process-messages.js.map